import styled from "@emotion/styled";
import { Button } from "@mui/material";

export const StyledSubmitButton = styled(Button)({
  paddingInline: "24px",
  paddingBlock: "4px",
  textTransform: "none",
  fontWeight: 700,
});
